import { useCallback } from 'react';
import { useAuthFetch } from '@cko/dashboard-shared';
import { QueryFunctionContext } from '@tanstack/react-query';

export type NetworkTokensSettingsResponse = {
  onboarded: boolean;
};

export const useGetNetworkTokensSettingsFetcher = () => {
  const fetch = useAuthFetch();

  return useCallback(
    async ({ queryKey }: QueryFunctionContext) => {
      const [basePath, { clientId }] = queryKey as [string, { clientId?: string }];

      if (!clientId) {
        return Promise.resolve({ onboarded: false });
      }

      const endpoint = `${basePath}/${clientId}/settings`;

      try {
        const response = await fetch(endpoint, {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' },
        });

        const networkTokensSettings: NetworkTokensSettingsResponse = await response.json();
        return networkTokensSettings;
      } catch (error) {
        return {
          onboarded: false,
        };
      }
    },
    [fetch],
  );
};
